<template>
  <div class="box">
    <!-- 标题box -->
    <div class="box_title">{{ title }}</div>
    <!-- 地址列表 -->
    <div class="mainBox">
      <div
        class="mainBox_list"
        v-for="(item, index) in subAccountList"
        :key="index"
      >
        <div class="mainBox_listText">{{ item.name }}</div>
        <div class="mainBox_listText">{{ item.pcAccount }}</div>
        <div class="mainBox_listBtn">是否自主开票</div>
        <div
          class="mainBox_BtnBox"
          :style="{
            'background-color': item.selfInvoicing ? '#09bb07' : '#fff',
            border: item.selfInvoicing ? '1px solid #09bb07' : '1px solid #bbb',
          }"
          @click="setInvoicing(item)"
        >
          <div
            :class="['circle', item.selfInvoicing ? 'circleTrue' : '']"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { doGet } from "../../common/HttpHelper.js";
import { httpConfig } from "../../common/config.js";
export default {
  props: {
    title: String,
    required: true,
  },
  data() {
    return {
      subAccountList: [], //子账号列表
      parentAccount: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
    };
  },
  mounted() {
    this.getSubAccount();
  },
  methods: {
    /**
     * 查询子账号
     */
    getSubAccount() {
      var that = this;
      doGet(
        httpConfig.subAccount.getSubAccountUrl,
        { parentAccount: this.parentAccount },
        function (res) {
          that.subAccountList = res.data;
        },
        function (res) {}
      );
    },
    /**
     * 设置是否自主开票
     */
    setInvoicing(item) {
      const loading = this.$loading({
        lock: false,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var that = this;
      doGet(
        httpConfig.subAccount.setSubAccountInvoicingUrl,
        {
          pcAccount: item.pcAccount,
          selfInvoicing: item.selfInvoicing ? 0 : 1,
        },
        function (res) {
          loading.close();
          if (res.flag) {
            that.getSubAccount();
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
  },
};
</script>
<style scoped>
@import "../../../assets/css/personal/subAccount";
</style>



// WEBPACK FOOTER //
// src/components/page/personal/subAccount.vue